import { Switch } from 'antd';
import s from './index.module.css';

export const ScheduleInGoogleCalendar = ({checked}) => {
    
    return (
       <div className={s.wrapper}>
            <Switch
                checked={checked}
                disabled
            />
            <span className={s.text}>Запланировано в Google Calendar</span>
       </div>
    )
}
